var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFaThinArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4015 8.3393L7.46403 12.2768C7.40306 12.338 7.33062 12.3865 7.25085 12.4196C7.17108 12.4528 7.08556 12.4698 6.99919 12.4698C6.91281 12.4698 6.82729 12.4528 6.74752 12.4196C6.66775 12.3865 6.59531 12.338 6.53434 12.2768L2.59684 8.3393C2.47356 8.21601 2.4043 8.0488 2.4043 7.87445C2.4043 7.7001 2.47356 7.53289 2.59684 7.40961C2.72013 7.28632 2.88734 7.21706 3.06169 7.21706C3.23604 7.21706 3.40324 7.28632 3.52653 7.40961L6.34348 10.2266V2.1875C6.34348 2.01345 6.41262 1.84653 6.53569 1.72346C6.65876 1.60039 6.82568 1.53125 6.99973 1.53125C7.17378 1.53125 7.3407 1.60039 7.46377 1.72346C7.58684 1.84653 7.65598 2.01345 7.65598 2.1875V10.2266L10.4729 7.40906C10.5962 7.28578 10.7634 7.21652 10.9378 7.21652C11.1121 7.21652 11.2793 7.28578 11.4026 7.40906C11.5259 7.53235 11.5952 7.69956 11.5952 7.87391C11.5952 8.04826 11.5259 8.21547 11.4026 8.33875L11.4015 8.3393Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaThinArrowDown);
export default __webpack_public_path__ + "static/media/fa-thin-arrow-down.48c3ce55fa4c845a61e96a9120a7d9d0.svg";
export { ForwardRef as ReactComponent };